import script from "./FranchiseDayBottleList.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDayBottleList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import BottleRow from "@/components/neue/BottleRow.vue";
import EmptyState from "@/components/neue/EmptyState.vue";
import NeueLoading from "@/components/neue/NeueLoading.vue";
import NeuePagination from "@/components/neue/NeuePagination.vue";
import NeueTablist from "@/components/neue/NeueTablist.vue";
import TablistRow from "@/components/neue/TablistRow.vue";
script.components = Object.assign({}, { BottleRow, EmptyState, NeueLoading, NeuePagination, NeueTablist, TablistRow }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BottleRow, EmptyState, NeueLoading, NeuePagination, NeueTablist, TablistRow }, script.__o.components);}